import script from "./ChatInputBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatInputBar.vue?vue&type=script&setup=true&lang=ts"

import "./ChatInputBar.vue?vue&type=style&index=0&id=7f15d9b7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f15d9b7"]])

export default __exports__